import React from 'react';
import PostCard from './PostCard';
type Post = {
  id: string;
  username: string;
  avatar: string;
  timestamp: string;
  content: string;
  sentiment: 'positive' | 'negative' | 'neutral';
  similarity: number;
};
type SocialStreamProps = {
  posts: Post[];
  matchedPost: Post | null;
};
const SocialStream: React.FC<SocialStreamProps> = ({
  posts,
  matchedPost
}) => {
  return <div className="h-full flex flex-col" data-id="element-109">
      <div className="p-4 border-b border-gray-700 flex justify-between items-center" data-id="element-110">
        <h2 className="text-xl font-semibold" data-id="element-111">Social Stream</h2>
        <div className="text-xs text-gray-400" data-id="element-112">Live updates</div>
      </div>
      <div className="flex-1 overflow-y-auto p-2 space-y-2" data-id="element-113">
        {posts.map(post => <PostCard key={post.id} post={post} isMatched={matchedPost?.id === post.id} data-id="element-114" />)}
      </div>
    </div>;
};
export default SocialStream;